import { isEmpty } from './commonFunc'
import { TOKEN_TOUCHED_AT_KEY, U_ENC_KEY } from './constants'
import { decryptAES, encryptAES } from './forgeencryption'

if (!U_ENC_KEY) {
  throw new Error('Some key not found.')
}

export const loadState = (key: string) => {
  try {
    if (typeof window !== 'undefined') {
      let serializeState = localStorage.getItem(key)

      if (['user', 'ctxVal'].includes(key) && serializeState != null) {
        serializeState = decryptAES(serializeState, U_ENC_KEY)
      }

      if (
        isEmpty(serializeState) ||
        typeof serializeState === 'object' ||
        serializeState === 'undefined'
      ) {
        return serializeState
      }

      return JSON.parse(serializeState)
    }
  } catch (error) {
    console.error('Err:Utils: Local Storage load save:', error)
  }
}

export const saveState = (key: string, state: any) => {
  try {
    if (typeof window !== 'undefined') {
      let serializeState = JSON.stringify(state)
      if (['user', 'ctxVal'].includes(key))
        serializeState = encryptAES(serializeState, U_ENC_KEY)?.encryptedData
      localStorage.setItem(key, serializeState)
    }
  } catch (error) {
    console.error('Err:Utils: Local Storage state save:', error)
  }
}

export const deleteLocalStorageAndCookies = async () => {
  if (typeof window !== 'undefined') {
    // Clear only user-specific localStorage keys (keep city preference)
    const userLocalStorageKeys = [
      'ctxVal',
      'user',
      'uidx',
      'abcAxis',
      'selectedPincode',
      TOKEN_TOUCHED_AT_KEY,
    ]
    userLocalStorageKeys.forEach((key) => localStorage.removeItem(key))

    // Clear only user-specific cookies (keep device-related cookies like isMobile)
    const userCookies = [
      'token',
      'orderStateCookie',
      'wasRedirectedFromPayment',
    ]
    userCookies.forEach((name) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
    })
  }
}

export const setCookie = (
  name: string,
  value: string,
  maxAgeSeconds: number,
  path: string = '/'
) => {
  if (typeof window !== 'undefined') {
    const expires = new Date()
    expires.setTime(expires.getTime() + maxAgeSeconds * 1000)
    const cookieString = `${name}=${encodeURIComponent(
      value
    )}; max-age=${maxAgeSeconds}; path=${path}; expires=${expires.toUTCString()}`
    document.cookie = cookieString
  }
}

export const deleteCookie = (name: string, path: string = '/') => {
  if (typeof window !== 'undefined') {
    // Set the cookie with the same name and an expired date to delete it
    document.cookie = `${name}=; max-age=0; path=${path};`
  }
}

export const getCookie = (name: string): string | any => {
  if (typeof window !== 'undefined') {
    const cookies = document.cookie.split('; ')
    const cookie = cookies.find((cookie) => cookie.startsWith(name + '='))

    if (cookie) {
      const cookieValue = cookie.split('=')[1]
      return decodeURIComponent(cookieValue) // Decode if it's URL-encoded
    }
    return ''
  }
  return ''
}
